import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const getAllSubDistrictAutocomplete = () => {
  return axiosGet(
    appsettings.digtalIdAPIUrl +
      "api/AddressUtils/GetAllSubDistrictAutocomplete"
  );
};

const getAddressBySubDistrictCode = (subDistrictCode) => {
  const params = {
    subDistrictName: subDistrictCode,
  };
  return axiosGet(
    appsettings.digtalIdAPIUrl + "api/AddressUtils/GetAddressBySubDistrictName",
    params
  );
};

const getValidateTumbolName = (subDistrictCode) => {
  const params = {
    subDistrictName: subDistrictCode,
  };
  return axiosGet(
    appsettings.digtalIdAPIUrl + "api/AddressUtils/GetValidateTumbolName",
    params
  );
};

export { getAllSubDistrictAutocomplete, getAddressBySubDistrictCode, getValidateTumbolName };
